/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import { App, plugin } from '@inertiajs/inertia-vue'
import Vue from 'vue';
import Vue2Filters from 'vue2-filters'
import moment from 'moment';
import VueClipboard from 'vue-clipboard2'
import BootstrapVuePlugin from 'bootstrap-vue';

import { Inertia } from '@inertiajs/inertia'
Inertia.on('navigate', (event) => {
});

Vue.use(BootstrapVuePlugin);
Vue.use(plugin);
Vue.use(Vue2Filters)
Vue.use(VueClipboard)

import Link from "@inertiajs/inertia-vue";
Vue.component('Link', Link.Link);
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding pages to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = document.getElementById('app');

import Lang from 'lang.js';

const default_locale = window.default_language;
const fallback_locale = window.fallback_locale;
const messages = window.messages;

const moment1 = require('vue-moment');
Vue.use(moment1);

Vue.prototype.trans = new Lang( { messages, locale: default_locale, fallback: fallback_locale } );
Vue.prototype.$route = (...args) => route(...args).url();

Vue.filter('toCurrency', function (value, locale) {
    if (typeof value !== "number") {
        return value;
    }

    var formatter = new Intl.NumberFormat(locale + '-CA', {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

Vue.filter('toTime', function (value, locale) {
    return value.substr(0,2) + ':' + value.substr(2,2);
});

Vue.filter('toDateYMD', function (value, locale) {
    return moment(value).format('YYYY-MM-DD');
});

Vue.filter('toDateLong', function (value, locale) {
    return moment(value).format('dddd, MMMM D');
});

Vue.filter('toPercentage', function (dec, locale) {
    if (dec <= 1) {
        return parseFloat(dec * 100).toFixed(2) + "%";
    }
    return 'Please enter number less than or equal to 1'
});

const el = document.getElementById('app');

window.vueApp = new Vue({
    render: h => h(App, {
        props: {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: name => import(`./Pages/${name}`).then(module => module.default),
        },
    }),
}).$mount(el)


